import React, { useContext } from 'react'
import { Flex, Box } from 'reflexbox'
import styled, { ThemeContext } from 'styled-components'
import { Formik, Form } from 'formik'

import Modal from './Modal'
import Card from 'components/Card'
import Button from 'components/Button'
import Loader from 'components/Loader'
import { Close } from 'components/Icons'
import { SemiTitle } from 'components/Typography'
import { CheckboxField } from 'components/Form'

const TermsModal = ({ isOpened, setIsOpened, action, isLoading, termsText, termsPDF }) => {
  const theme = useContext(ThemeContext)

  return (
    <Modal isOpened={isOpened} setIsOpened={setIsOpened}>
      <Card bg={theme.colors.white} p={24}>
        <Flex flexDirection='column'>
          <Flex width={1} justifyContent='space-between' mb={16}>
            <SemiTitle>Termos e condições de uso</SemiTitle>
            <CloseButton onClick={() => setIsOpened(false)}>
              <Close />
            </CloseButton>
          </Flex>
          <a href={termsPDF} target='_blank' download>
            Baixar PDF
          </a>
          <TermsContainer mb={24} mt={24}>
            <pre>{termsText}</pre>
          </TermsContainer>

          <Formik initialValues={{ accept_terms: false }} onSubmit={action}>
            {({ values }) => (
              <Form>
                <CheckboxField name='accept_terms' label='Li e aceito os termos e condições de uso' />
                <Flex width={1} justifyContent='flex-end'>
                  <Button mr={24} outlined onClick={() => setIsOpened(false)} type='button'>
                    Cancelar
                  </Button>
                  <Button type='submit' disabled={!values.accept_terms || isLoading}>
                    {isLoading ? <Loader /> : 'Aceitar'}
                  </Button>
                </Flex>
              </Form>
            )}
          </Formik>
        </Flex>
      </Card>
    </Modal>
  )
}

const TermsContainer = styled(Box)`
  border: 1px solid ${({ theme }) => theme.colors.grays.N300};
  padding: 16px;
  max-width: 744px;
  max-height: 300px;
  min-height: 250px;
  overflow-y: scroll;
`

const CloseButton = styled.button`
  border: 0;
  background: transparent;
  cursor: pointer;
`

export default TermsModal
